import type { SendMessagesState } from './types';

const initialState: SendMessagesState = {
  text: {},
  swipeNoteText: {},
  gif: {
    content: null,
    error: false,
  },
  sticker: {
    content: null,
    error: false,
  },
  vinyl: {
    recentlySent: [],
  },
};

export default initialState;
